import { EEarlyAccessPreference } from 'apis/UsersApi';
import { ApiCaller } from 'apis/ApiCaller';

export type AppFeature = {
    name: string;
    description: string;
    displayName: string;
    isAllowed: boolean;
    isEnabled: boolean;
};

export type UserPartner = {
    Name: string;
    PartnerId: number;
    Type: number;
};

export type AppUser = {
    id: string;
    active: boolean;
    earlyAccessPreference: EEarlyAccessPreference;
    email: string;
    firstName: string;
    fullName: string;
    hasAuthoringAccount: boolean;
    hasStudentAccount: boolean;
    lastName: string;
    needsPasswordReset: boolean;
    phoneNumber: string;
    userName: string;
    userProfileId: number;
};

export type HighestRole = {
    id: number;
    name: string;
    partnerId: number;
};

export type SelectedPartner = {
    id: number;
    name: string;
    sector: number;
    type: number;
};

export type Language = {
    Id: number;
    Name: string;
}

export type AppBasicsReturnValue = {
    allowedItems: string[];
    cultureId: number;
    cultureTag: string;
    currentUser: AppUser;
    features: AppFeature[];
    highestRole: HighestRole;
    languages: Language[];
    pendingOrderCount: number;
    selectedPartner: SelectedPartner;
    sideNavOpen: boolean;
    supportPillWidgetCollapsed: boolean;
    userId: number;
    userPartners: UserPartner[];
};

export class AppApi {

    private static apiCaller = new ApiCaller('App');

    private static apiCallerPublic = new ApiCaller('Public');

    public static GetBasics(): Promise<AppBasicsReturnValue> {

        return this.apiCallerPublic.GET<AppBasicsReturnValue>('GetAppBasics');

    }

}
